module.exports = __webpack_public_path__ + "static/media/travel (1).745d9c6c.png";